var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ocr-dialog",
    {
      attrs: {
        title: _vm.title,
        "custom-class": "intelligent-booking-result-dialog",
        visible: _vm.innerVisible,
        fullscreen: "",
        width: "100%",
        top: "0vh",
        modal: false,
        "can-maximize": true,
        "can-minimize": true,
        "only-can-minimize": true,
        "append-to-body": true,
        "close-class": _vm.windowMin
          ? "padding-right: 980px"
          : "padding-right: 1px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: function($event) {
          return _vm.$emit("close")
        },
        modalMin: function($event) {
          _vm.windowMin = true
        },
        restore: function($event) {
          _vm.windowMin = false
        }
      }
    },
    [
      _vm.innerVisible
        ? _c("intelligent-booking-result-common", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              visible: _vm.innerVisible,
              details: _vm.detailList[_vm.pageNum - 1],
              source: _vm.source
            },
            on: {
              toNext: _vm.toNext,
              close: function($event) {
                return _vm.$emit("close")
              },
              success: function($event) {
                return _vm.$emit("success")
              },
              copyIntelligentDocument: function(res) {
                _vm.$emit("copyIntelligentDocument", res)
              }
            }
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-pagination", {
            staticStyle: { right: "200px" },
            attrs: {
              background: "",
              "current-page": _vm.pageNum,
              "pager-count": 5,
              "page-size": 1,
              layout: "prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "update:currentPage": function($event) {
                _vm.pageNum = $event
              },
              "update:current-page": function($event) {
                _vm.pageNum = $event
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }